import styled from '@emotion/styled';

import type { ISidebarNav } from '../helpers/types';
import { useIsChildOpen } from '../hooks/useIsChildOpen';
import { FrontMenuItem } from './FrontMenuItem';

export const FrontMenuItemChild = ({ item }: { item: ISidebarNav }) => {
  const isChildOpen = useIsChildOpen();
  return (
    <ChildrenWrapper
      style={{ height: isChildOpen(item.key) ? 36 * (item.children?.length || 0) : 0 }}
    >
      {item.children?.map((child, key) => (
        <div key={key}>
          <FrontMenuItem item={child} isChild />
        </div>
      ))}
    </ChildrenWrapper>
  );
};

const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: height 0.3s ease-in-out;
  overflow: hidden;
`;
